import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/wpressr': {
    width: 496,
    height: 512,
    paths: [
      {
        d: 'M248 8c137 0 248 111 248 248s-111 248-248 248-248-111-248-248 111-248 248-248zM419.3 166.6c2.4-5.5 0.5-8.3-5.6-8.3-104.8 0-107.7 0-130.8 0-4.3 0-7.1 1.8-8.8 5.8-5.7 13.1-11.5 26.2-17.3 39.2-2.6 5.8-1 8.3 5.3 8.3 25.3 0 50.5 0 75.8 0 10 0 8.5 13.7-3.9 13.6-26.4 0-52.9 0-79.3 0-4.9 0-8.3 1.9-10.4 6.5-4.3 9.8-32.1 73.1-32.2 73.2-3.2 7.2-16.3 6.1-11.3-5.3 8.3-19 16.7-37.9 25-56.9 2.3-5.1-0.1-8.7-5.7-8.8-15.2 0-30.4 0-45.6 0-3.4 0-5.4 1.3-6.8 4.4-31.4 71.9-29.8 67.3-30 67.7-3.9 6.4-14.9 3.3-11-5.6 5.7-13 11.4-26 17.1-39 13.6-30.8 27.1-61.6 40.7-92.3 2.5-5.8-0.4-10.6-6.7-10.6-14.2 0-28.5 0-42.7 0-4.3 0-6.8 1.8-8.5 5.7-12.9 29.4-25.8 58.7-38.8 88.1-8.6 19.6-17.2 39.1-25.9 58.7-1.6 3.6-1.5 6.8 1.2 9.7 11.2 12.3 22.5 24.6 33.7 36.9 2.1 2.3 4.6 3.5 7.7 3.5 45.9 0 91.9 0 137.8 0 3.9 0 6.4-1.8 7.9-5.3 10.3-23.5 20.8-46.9 31-70.5 2.1-4.8 5.2-6.8 10.3-6.7 23 0.1 46 0 69.1 0 6.1 0 10.5-2.7 13-8.2 15.3-34.5 30.5-69 45.6-103.5z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/wpressr.js
// module id = 1101
// module chunks = 0